import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  stickyHeader: {
    backgroundColor: '#ffffff',
  },
}));

export default useStyles;
